/* eslint-disable no-param-reassign,no-underscore-dangle */
const TranslatePlugin = {
  install(Vue) {
    Vue.dictionary = {};

    Vue.mixin({
      methods: {
        addDictionary(dict) {
          const prefixKeys = (obj) => Object.keys(obj)
            .reduce(
              (acc, key) => ({
                ...acc,
                ...{ [`${this.$root._uid}_${key}`]: obj[key] },
              }),
              {},
            );

          Vue.dictionary = { ...Vue.dictionary, ...prefixKeys(dict) };
        },
        translate(key, replacements) {
          if (`${this.$root._uid}_${key}` in Vue.dictionary) {
            // console.info(`Found translation for key ${key}.`);
            let translation = Vue.dictionary[`${this.$root._uid}_${key}`];

            if (replacements) {
              const placeholders = [];
              const search = new RegExp(/\{([^{}]*)\}/g);

              let found = search.exec(translation);
              while (found !== null) {
                placeholders.push(found[1]);
                found = search.exec(translation);
              }

              placeholders.forEach((placeholder) => {
                if (replacements[placeholder]) {
                  translation = translation.replaceAll(`{${placeholder}}`, replacements[placeholder]);
                }
              });
            }
            return translation;
          }
          console.warn(`Translation for key ${key} not found.`);
          return key;
        },
      },
    });

    Vue.filter('round', (value, decimals) => {
      if (!value) value = 0;
      if (!decimals) decimals = 0;
      return Math.round(value * (10 ** decimals)) / (10 ** decimals);
    });

    Vue.filter('formatDate', (date, locale) => date.toLocaleDateString(
      locale,
      { day: '2-digit', month: '2-digit', year: 'numeric' },
    ));

    Vue.filter('customFormatDate', (date, string) => window.moment(date).format(string));
  },
};

export default TranslatePlugin;
